import { Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { CompanyClientDto, CreateCompanyClientDto } from 'tdc-web-backend/company-client/schemas';
import useCreate from '../../../../utils/hooks/crud-hooks/useCreate';
import ControlledDropzoneFileInput from '../../../../components/custom-inputs/ControlledDropzoneFileInput/ControlledDropzoneFileInput';
import { getBase64 } from '../../../../utils/helpers';
import { primaryDark, secondaryBlue } from '../../../../utils/color';
import CustomButton from '../../../../components/button/CustomButton';
import { ReactComponent as FileUploadSvg } from '../../../../assets/icons/project-icons/FileUploadSvg.svg';
import CustomModal from '../../../../components/modal/CustomModal';

import { ReactComponent as ClipboardCheckIcon } from '../../../../assets/icons/layout-icons/ClipboardCheckIcon.svg';
import { AddClientModalProps } from '../interface';
import CustomInput from '../../../../components/custom-input/CustomInput';

const AddClientModal = ({ isOpen, setIsOpen, append }: AddClientModalProps) => {
  const formMethods = useForm({
    defaultValues: {
      avatar: '',
      name: '',
    },
  });
  const { handleSubmit, formState } = formMethods;
  const [key, setKey] = useState(0);

  const { mutate: createCompanyClient, isLoading: isCreateCompanyClientLoading } = useCreate<
    CompanyClientDto,
    CreateCompanyClientDto
  >({
    resource: 'company-client',
  });
  //   const { avatar, name } = formMethods.watch();

  const onSubmit = (data: any) => {
    createCompanyClient(
      { avatar: data.avatar, name: data.name },
      {
        onSuccess: (response) => {
          const { data } = response;

          append(data);
          setKey((k) => k + 1);
          formMethods.reset({ avatar: '', name: '' });
          setIsOpen(false);
        },
        onError: (error) => {
          console.error('Error creating client:', error);
        },
      },
    );
  };

  const onUpload = async (acceptedFiles: File[], onChange: (...event: any[]) => void) => {
    const file = acceptedFiles?.[0];
    if (!file) return;

    const base64 = await getBase64(file);
    formMethods.setValue('avatar', base64 as string);
    formMethods.clearErrors('avatar');
  };

  const hasAvatarError = formState.errors ? Object.keys(formState.errors).includes('avatar') : null;

  return (
    <CustomModal open={isOpen} width="50%">
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center">
          <Stack
            width={40}
            height={40}
            mr={2}
            bgcolor="secondaryBlue.100"
            borderRadius={1}
            justifyContent="center"
            alignItems="center"
          >
            <ClipboardCheckIcon fill={secondaryBlue[700]} />
          </Stack>
          <Typography variant="heading5">Add Client</Typography>
        </Stack>
        <Divider />
        <FormProvider {...formMethods}>
          <form>
            <Stack direction="row" alignItems="center" gap={2.5} justifyContent="space-between">
              <Stack alignItems="center" justifyContent="center">
                <ControlledDropzoneFileInput
                  name="avatar"
                  onUpload={onUpload}
                  required
                  key={key}
                  dropzoneProps={{
                    multiple: false,
                  }}
                  renderCustomDroppableAreaWidth={135}
                  renderCustomDroppableAreaHeight={135}
                  renderCustomDroppableArea={({ getRootProps, getInputProps }) => (
                    <Stack
                      alignItems="center"
                      justifyContent="center"
                      {...getRootProps()}
                      spacing={1}
                      sx={{
                        width: 135,
                        height: 135,
                        borderRadius: '50%',
                        border: '2px dashed',
                        borderColor: hasAvatarError ? 'secondaryPink.500' : 'primaryDark.300',
                        '.MuiTypography-root': {
                          fontSize: '12px',
                        },
                        backgroundColor: hasAvatarError ? 'secondaryPink.100' : 'primaryDark.200',
                      }}
                    >
                      <input {...getInputProps()} />
                      <FileUploadSvg fill={primaryDark[400]} />
                      <Typography color="primaryDark.400" fontWeight="600">
                        ADD LOGO
                      </Typography>
                    </Stack>
                  )}
                />
                {hasAvatarError && (
                  <Typography
                    color="secondaryPink.500"
                    variant="body4"
                    sx={{ alignSelf: 'start', display: 'block', margin: '12px 0' }}
                  >
                    This field is required
                  </Typography>
                )}
              </Stack>
              {/* <ControlledTextInput
                sx={{ flex: 1, mb: 1 }}
                name="name"
                placeholder="Add client"
                required
                label="Client company name"
              /> */}
              <CustomInput
                input={<CustomInput.Text />}
                name="name"
                placeholder="Add client"
                label="Client company name"
                required
                sx={{ flex: 1, mb: 1 }}
              />
            </Stack>

            <Stack direction="row" sx={{ justifyContent: 'right' }} spacing={2}>
              <CustomButton
                variant="secondary"
                onClick={() => {
                  setIsOpen(false);
                }}
                disabled={isCreateCompanyClientLoading}
              >
                Cancel
              </CustomButton>
              <CustomButton
                loading={isCreateCompanyClientLoading}
                // onClick={() => onSubmit(formMethods.getValues())}
                onClick={handleSubmit(onSubmit)}
                // disabled={!(avatar?.length && name?.length)}
              >
                Add
              </CustomButton>
            </Stack>
          </form>
        </FormProvider>
      </Stack>
    </CustomModal>
  );
};

export default AddClientModal;
